import type { MutationCache, QueryCache } from '@tanstack/react-query';
import { isServer, QueryClient } from '@tanstack/react-query';

const makeQueryClient = (params?: {
  defaultOnError: (error: Error, variables: unknown, context: unknown) => void;
  mutationCache: MutationCache;
  queryCache: QueryCache;
}) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        // staleTime: 0,
        // gcTime: 0,
      },
      ...(params?.defaultOnError && {
        mutations: {
          onError: params?.defaultOnError,
        },
      }),
    },
    ...(params?.mutationCache && {
      mutationCache: params.mutationCache,
    }),
    ...(params?.queryCache && {
      queryCache: params.queryCache,
    }),
  });
  return queryClient;
};

let browserQueryClient: QueryClient | undefined;

export const getQueryClient = (params?: {
  defaultOnError: (error: Error, variables: unknown, context: unknown) => void;
  mutationCache: MutationCache;
  queryCache: QueryCache;
}) => {
  if (isServer) {
    return makeQueryClient();
  } else {
    if (!browserQueryClient) browserQueryClient = makeQueryClient(params);
    return browserQueryClient;
  }
};
